import React, { memo } from "react";
import PropTypes from "prop-types";
import MenuList from "@material-ui/core/MenuList";
import MenuItem from "@material-ui/core/MenuItem";
import Typography from "@material-ui/core/Typography";
import Email from "@material-ui/icons/MailOutline";
import Exit from "@material-ui/icons/ExitToApp";
import useStyles from "./M_UserArea.styles";

const M_ProfileMenu = (props) => {
  const classes = useStyles();
  const { t: translate, displayName, email } = props;
  const tr = (key) => (translate ? translate(key) : key);
  const hasHeader = Boolean((displayName && displayName.trim()) || email);

  const handleMenuClick = (clickedMenu) => {
    props.handleClose(clickedMenu);
  };

  const mailBox = () => {
    window.location = `mailto:help@htb.co.uk`;
  };

  return (
    <MenuList
      autoFocusItem={false}
      disablePadding
      aria-label="user menu"
      className={classes.profileMenuList}
    >
      {hasHeader && (
        <li className={classes.profileMenuHeader} aria-hidden="true">
          {displayName && displayName.trim() && (
            <Typography noWrap className={classes.profileMenuName}>
              {displayName}
            </Typography>
          )}
          {email && (
            <Typography noWrap className={classes.profileMenuEmail}>
              {email}
            </Typography>
          )}
        </li>
      )}
      {hasHeader && (
        <li
          className={classes.menuDivider}
          role="separator"
          aria-hidden="true"
        />
      )}
      <MenuItem
        disableGutters
        className={classes.profileMenuItem}
        onClick={mailBox}
      >
        <Email className={classes.profileMenuItemIcon} fontSize="small" />
        <Typography className={classes.profileMenuItemText}>
          {tr("Contact Support")}
        </Typography>
      </MenuItem>
      <li className={classes.menuDivider} role="separator" aria-hidden="true" />
      <MenuItem
        disableGutters
        className={`${classes.profileMenuItem} ${classes.profileLogoutItem}`}
        onClick={() => handleMenuClick("logout")}
      >
        <Exit className={classes.profileMenuItemIcon} fontSize="small" />
        <Typography className={classes.profileMenuItemText}>
          {tr("Logout")}
        </Typography>
      </MenuItem>
    </MenuList>
  );
};

M_ProfileMenu.propTypes = {
  t: PropTypes.any,
  handleClose: PropTypes.func,
  displayName: PropTypes.string,
  email: PropTypes.string,
};

export default memo(M_ProfileMenu);
